module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_GA-66c69b19e20aca984a0e3e9b4f0133ab.svg";